/**
 * Engineer disciplines — the roster vocabulary.
 *
 * This exists because the list used to be a binary written out longhand in
 * five places (`d === 'controls' ? 'Controls' : 'Process'`). That is fine for
 * two values and silently wrong for three: a Mechanical engineer would have
 * read as Process on the card, in the CSV, and — worse — been REWRITTEN to
 * process the next time anyone opened their edit form.
 *
 * A discipline and a CALENDAR GROUP are deliberately not the same thing.
 * Mechanical is its own trade on the engineer card, in the Resources list and
 * in the export, but on the Manpower calendar it is read alongside Controls,
 * which is how the team looks at the board. Keeping the two as separate
 * concepts is what lets that be true without lying about anybody's discipline.
 *
 * NOT the same vocabulary as the SVM checklist "discipline"
 * (views/engineer/checklists, `svm-sealer-process` and friends). That one is a
 * book of checklists; this one is a person's trade. Do not merge them.
 */

export const DISCIPLINES = [
  { key: 'controls', label: 'Controls', calendarGroup: 'controls' },
  { key: 'process', label: 'Process', calendarGroup: 'process' },
  { key: 'mechanical', label: 'Mechanical', calendarGroup: 'controls' },
];

export const DEFAULT_DISCIPLINE = 'process';

/** The grids the Manpower calendar draws, in order. Controls above Process. */
export const CALENDAR_GROUPS = [
  { key: 'controls', title: 'Controls Engineers' },
  { key: 'process', title: 'Process Engineers' },
];

/** Anything unrecognised (legacy rows, typos) reads as the default rather
 *  than dropping the engineer out of a grouped view entirely. */
export const disciplineOf = (v) => {
  const k = String(v || '')
    .toLowerCase()
    .trim();
  return DISCIPLINES.some((d) => d.key === k) ? k : DEFAULT_DISCIPLINE;
};

const entry = (v) => DISCIPLINES.find((d) => d.key === disciplineOf(v));

export const disciplineLabel = (v) => entry(v).label;

/** Which calendar grid this engineer is drawn in. Mechanical → Controls. */
export const calendarGroupOf = (v) => entry(v).calendarGroup;
